import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import PixelRain from "./components/PixelRain";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import PortfolioPage from "./pages/PortfolioPage";
import ContactPage from "./pages/ContactPage";
import GrowthOSPage from "./pages/GrowthOSPage";

const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // A shared deep link like /portfolio#dashboard must land on that chapter,
    // so only reset the scroll position when no target was asked for.
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ behavior: "instant" as ScrollBehavior });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, hash]);
  return null;
};

const App: React.FC = () => {
  return (
    <div dir="rtl" className="grain font-heebo">
      <ScrollToTop />
      <a
        href="#main"
        className="btn btn-primary sr-only focus:not-sr-only focus:fixed focus:right-4 focus:top-4 focus:z-[70]"
      >
        דילוג לתוכן
      </a>
      <Navigation />
      <PixelRain />
      <main id="main" className="min-h-screen">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/growth-os" element={<GrowthOSPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default App;
